import { useTranslation } from "react-i18next";
import { Link } from "react-router";

/**
 * The page behind a question to the model that the administrator has switched
 * off. Since 2026-09-28; the decision is in `project-scope.md`.
 *
 * `OwnersOnly`'s shape and its argument: the link is gone, but an address can
 * still be typed or kept in a bookmark, and a sentence that says what happened
 * is better than a redirect that looks like the page was lost. Quiet text, not
 * an alert — nothing has gone wrong.
 */
export function SwitchedOff({ cellarId }: { cellarId: string }) {
  const { t } = useTranslation();

  return (
    <p className="text-muted mt-6 max-w-prose text-sm">
      {t("features.switchedOff")}{" "}
      <Link
        to={`/kallare/${cellarId}`}
        className="text-accent underline-offset-4 hover:underline"
      >
        {t("guest.backToWines")}
      </Link>
    </p>
  );
}
